import React, { useState } from 'react';
import { Modal, Form, Rate, Input, Button, message } from 'antd';
import reviewService from '../../services/reviewService';

const { TextArea } = Input;

/**
 * ReviewForm - handles both product and service reviews
 * @param {string} type - 'product' or 'service'
 * @param {number} itemId - productId or serviceId
 * @param {number} referenceId - orderItemId or appointmentId
 * @param {string} itemName - name to display in title
 */
const ReviewForm = ({ visible, onClose, onSuccess, type = 'product', itemId, referenceId, itemName }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (type === 'product') {
        await reviewService.createProductReview({
          product: itemId,
          order_item_id: referenceId,
          rating: values.rating,
          comment: values.comment || '',
        });
      } else {
        await reviewService.createServiceReview({
          service: itemId,
          appointment_id: referenceId,
          rating: values.rating,
          comment: values.comment || '',
        });
      }
      message.success('Review submitted successfully!');
      form.resetFields();
      onSuccess?.();
      onClose();
    } catch (error) {
      const errorMsg = error.response?.data?.detail ||
                       error.response?.data?.non_field_errors?.[0] ||
                       'Failed to submit review';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Review: ${itemName}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="rating"
          label="Your Rating"
          rules={[{ required: true, message: 'Please select a rating' }]}
        >
          <Rate style={{ fontSize: 32 }} />
        </Form.Item>

        <Form.Item
          name="comment"
          label="Your Review (optional)"
        >
          <TextArea
            rows={4}
            placeholder="Share your experience with this product..."
            maxLength={1000}
            showCount
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Submit Review
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReviewForm;
